module.exports = __webpack_public_path__ + "img/vchasno.58e63523.webp";